module.exports = __webpack_public_path__ + "static/media/service-qa.8500f04e.svg";